import {convertToUrlParams} from 'utils'
import baseApi, {provideTag} from './baseApi'

const consumersApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getConsumers: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `consumers${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: () => provideTag('Consumer'),
        }),
        getConsumer: build.query({
            query: (id) => {
                return {
                    url: `consumers/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('Consumer', result),
        }),
        deleteConsumer: build.mutation({
            query: (id) => {
                return {
                    url: `consumers/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Consumer'],
        }),
        createConsumer: build.mutation({
            query: (data) => {
                return {
                    url: `consumers`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Consumer'],
        }),
        editConsumer: build.mutation({
            query: (data) => {
                return {
                    url: `consumers/${data._id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Consumer'],
        }),
    }),
    overrideExisting: false,
})

export default consumersApi

export const {
    useGetConsumersQuery,
    useGetConsumerQuery,
    useDeleteConsumerMutation,
    useCreateConsumerMutation,
    useEditConsumerMutation,
} = consumersApi
